import { createContext, useContext } from 'react'

export interface SideBarState {
  isCollapsed: boolean
}

const SideBarContext = createContext<SideBarState>({ isCollapsed: false })
SideBarContext.displayName = 'SideBarContext'

export const SideBarContextProvider = SideBarContext.Provider

export function useSideBar(): SideBarState {
  const values = useContext(SideBarContext)

  return values ?? { isCollapsed: false }
}
